export default {
  'menu.pages': 'Pages',
  'menu.features': 'Features',
  'menu.tenants': 'Tenants',
  'menu.subscriptions': 'Subscriptions',
  'menu.adminMarketplace': 'Marketplace',
  'menu.adminMarketplaceFeatures': 'Marketplace Features',
  'menu.schedulers': 'Schedulers',
  'menu.dashboard': 'Dashboard',
  'menu.home': 'Home',
  'menu.roles': 'Roles',
  'menu.profile': 'Profile',
  'menu.management': 'Management',
  'menu.logout': 'Logout',
  'menu.credits': 'Credits',
  'menu.revenue': 'Revenue',
  'menu.entitlements': 'Entitlements',
};
